module.exports = __webpack_public_path__ + "img/pup-boy.93009231.svg";